import React from "react";
import { Link } from "react-router-dom";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import FeatherIcon from "feather-icons-react";
import logobetadark from "../../../assets/images/DBinsightai-Horizonlogo.svg";
import logobetalight from "../../../assets/images/DBinsightai-Horizonlogo-white.svg";


const PrivacyPolicy = () => {
  document.title = "Privacy Policy |DBInsight - React Admin & Dashboard Template";
  return (
    <React.Fragment>
      <div className="page-content pt-20">
        <Container fluid>
        <Row>
            <Col>
            <div className="horizontal-logo t_C mb-30">
                <Link to="/" className="logo-f logo-dark h-100">
                    <span className="logo-lg">
                        {/* <img src={logoDark} alt=""/> */}
                        <img src={logobetadark} alt="" height="80"/>
                    </span>
                </Link>

                <Link to="/" className="logo-f logo-light h-100">
                    <span className="logo-lg">
                        {/* <img src={logoLight} alt=""/> */}
                        <img src={logobetalight} alt="" height="80"/>
                    </span>
                </Link>
            </div>
            </Col>
          </Row>
          {/* <BreadCrumb title="Privacy Policy" pageTitle="Pages" /> */}
          <Row className="justify-content-center">
            <Col lg={10}>
              <Card>
                <div className="bg-dark-subtle position-relative">
                  <CardBody className="p-5">
                    <div className="text-center">
                      <h3>Privacy Policy</h3>
                      <p className="mb-0 text-muted">
                      Effective Date: September 19th, 2024
                      </p>
                    </div>
                  </CardBody>
                  <div className="shape">
                    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="1440" height="60" preserveAspectRatio="none" viewBox="0 0 1440 60">
                      <g mask="url(&quot;#SvgjsMask1001&quot;)" fill="none">
                        <path d="M 0,4 C 144,13 432,48 720,49 C 1008,50 1296,17 1440,9L1440 60L0 60z" style={{fill: "var(--vz-secondary-bg)"}}></path>
                      </g>
                      <defs>
                        <mask id="SvgjsMask1001">
                          <rect width="1440" height="60" fill="#ffffff"></rect>
                        </mask>
                      </defs>
                    </svg>
                  </div>
                </div>
                <CardBody className="p-4">
                  <p>Welcome to DBinsight.ai! The protection of your personal information is of utmost importance to us. This Privacy Policy explains how we collect, use, store, share, and protect your personal information when you use the products and services offered by DBinsight.ai. It also outlines your rights and how you can exercise them.</p>
                  <p>Please read this Privacy Policy carefully to understand how your personal information is handled. By using our platform, you confirm that you have read, understood, and agreed to this Privacy Policy. If you disagree with any part of the policy, please stop using our services immediately.</p>
                  <p>If you have any questions or concerns regarding this Privacy Policy, you can contact us at info@dbinsight.ai.</p>
                  
                  <div className="">
                      <h5 className="text-dark">I. How We Collect and Use Your Personal Information</h5>
                      <h6 className="text-dark">1. Personal Information Collected Directly from Users</h6>
                      <p>We collect the following types of personal information directly from you:
                      </p>
                      <ul> 
                        <li><b>Account Registration</b>: Email address, phone number, and password</li>
                        <li><b>Payment Information</b>: Billing details, such as payment methods, for processing transactions.</li>
                        <li><b>Uploaded Content</b>: Input data, uploaded files, or feedback provided by you.</li>
                        <li><b>Voice Input</b>: If you use voice input, microphone access is required.</li>
                      </ul>
                      <p>
                      If you do not provide the required information, certain features or services may not function properly.
                      </p>

                      <h6 className="text-dark">2. System Data Collected Automatically</h6>
                      <p>When you use our platform, we collect the following data for functionality, analytics, and security:</p>
                      <ul>
                        <li><b>IP Address</b></li>
                        <li><b>Time Zone and System Time</b></li>
                        <li><b>Cookies</b></li>
                        <li><b>Browser Type and Language Preferences</b></li>
                      </ul>
                      <h6 className="text-dark">3. Third-Party Integrations</h6>
                      <p>If you integrate third-party services (e.g Stripe), we may collect and process relevant data, such as credit card information, with your explicit consent. This data will only be used to provide the agreed-upon services and will not be retained for other purposes.</p>
                      <h6 className="text-dark">4. Aggregated Data</h6>
                      <p>We may aggregate and anonymize personal information to generate statistical insights and improve our services. Aggregated data does not identify individuals and is not considered personal information under the law.</p>
                    
                  </div>
                  <div>
                    <h5 className="text-dark">II. How We Use Cookies and Similar Technologies</h5>
                    <p>We use cookies and similar technologies to:</p>
                    <ul>
                      <li>Authenticate logins.</li>
                      <li>Personalize your experience.</li>
                      <li>Analyze system performance and user behavior.</li>
                    </ul>
                    <p>You can manage or delete cookies through your browser settings. However, disabling cookies may limit certain functionalities of the platform.</p>
                  </div>

                  <div>
                    <h5 className="text-dark">III. Authorization and Consent of End Users</h5>
                    <p>If you are a partner integrating DBinsight.ai services, you must:</p>
                    <ul>
                      <li>Inform your end users about data collection and processing.</li>
                      <li>Obtain their consent.</li>
                      <li>Comply with applicable legal obligations regarding data protection.</li>
                    </ul>
                    <p>DBinsight.ai processes end-user data solely based on your instructions and does not control how you handle end-user data.</p>
                  </div>

                  <div>
                    <h5 className="text-dark">IV. How We Share, Transfer, or Disclose Your Personal Information</h5>
                    <h6 className="text-dark">1. Sharing</h6>
                    <p>We do not share your personal information with third parties unless:</p>
                    <ul>
                      <li>You have provided explicit consent.</li>
                      <li>It is necessary to provide services (e.g., sharing with service providers like email or analytics platforms).</li>
                      <li>It is required by law or for public interest (e.g., national security or legal proceedings).</li>
                      <li>It is shared with our affiliates under strict confidentiality agreements.</li>
                    </ul>
                    <p></p>
                  </div>   

                  <div>
                    <h6 className="text-dark">2. Transfer</h6>
                    <p>We will only transfer your personal information to another party under the following conditions:</p>
                    <ul>
                      <li>With your explicit consent.</li>
                      <li>During business changes, such as mergers or acquisitions, where the recipient will continue to comply with this privacy policy or seek your consent.</li>
                    </ul>
                  </div>   
                  <div>
                    <h6 className="text-dark">3. Public Disclosure</h6>
                    <p>We do not publicly disclose your personal information without your explicit consent, except as required by law.</p>
                  </div>

                  <div>
                    <h5 className="text-dark">V. How We Store Your Personal Information</h5>
                    <h6 className="text-dark">1. Storage Location</h6>
                    <p>Your personal information is stored on secure servers, and data may be transmitted internationally depending on service integrations. We comply with cross-border data protection requirements as applicable.</p>
                  </div> 

                  <div>
                    <h6 className="text-dark">2. Storage Period</h6>
                    <p>We retain your personal information only as long as necessary for the purposes outlined in this Privacy Policy. Once the retention period expires, we delete or anonymize your data, unless otherwise required by law.</p>
                  </div>

                  <div>
                    <h5 className="text-dark">VI. How We Protect Your Personal Information</h5>
                    <p>We implement industry-standard security measures, including:</p>
                    <ul>
                      <li><b>SSL Encryption</b>: Protecting data transmission between your browser and our platform.</li>
                      <li><b>Access Controls</b>: Ensuring only authorized personnel can access your data.</li>
                      <li><b>Employee Training</b>: Enhancing awareness of data privacy and security.</li>
                    </ul>
                    <p>While we take all reasonable precautions, no system is entirely secure. By using our services, you acknowledge and accept the inherent risks.</p>
                    <p>In case of a data breach, we will notify affected users and relevant authorities promptly, as required by law.</p>
                  </div>


                  <div>
                    <h5 className="text-dark">VII. How You Exercise the Rights in Personal Information</h5>
                  
                    <p>You have the following rights regarding your personal information:</p>
                    <ul>
                      <li><b>Access and Update</b>: Modify your data through your account or by contacting us.</li>
                      <li><b>Delete Data</b>: Request deletion if data collection violates laws or agreements.</li>
                      <li><b>Withdraw Consent</b>: Withdraw consent for data processing (may limit functionality).</li>
                      <li><b>Cancel Account</b>: Delete your DBinsight.ai account, which also erases your data.</li>
                      <li><b>Refuse Marketing</b>: Opt out of promotional communications.</li>
                      <li><b>Deceased User Data</b>: Close relatives can request access or deletion of a deceased user’s data.</li>
                    </ul>
                    <p>To exercise these rights, contact <a href="mailto:info@dbinsight.ai.">info@dbinsight.ai.</a> We will respond within 20 business days.</p>
                  </div>              


                  <div>
                    <h5 className="text-dark">VIII. How We Process Children’s Personal Information</h5>                    
                    <p>DBinsight.ai does not knowingly collect personal information from children. If you are a partner targeting children, ensure you have obtained guardian consent and comply with applicable laws. Unauthorized data will be deleted upon discovery or notification.</p>
                  </div>
                  <div>
                    <h5 className="text-dark">IX. How We Update and Revise This Privacy Policy</h5>
                   
                    <p>We may revise this Privacy Policy from time to time. Major updates will be communicated via email or announcements. Continued use of our services after updates signifies your acceptance of the revised policy.</p>
                  </div>
                  <div>
                    <h5 className="text-dark">X. How You Contact Us</h5>
                    <p>
                    For questions or concerns about this Privacy Policy, you can contact us at:<br/>
                    <b>Email:</b> <a href="mailto:info@dbinsight.ai">info@dbinsight.ai</a><br/>
                    We aim to respond to all inquiries within 20 business days.
                    </p>
                  </div>
                  <div>
                    <h5 className="text-dark">XI. Global Data Privacy Compliance</h5>
                    <p>We are committed to protecting your personal information and ensuring compliance with applicable data protection laws worldwide. Depending on where you are located, your data may be processed in accordance with the following regulations:</p>
                    <ul>
                      <li><b>GDPR (EEA and UK)</b>: Ensuring lawful processing, user rights, and cross-border safeguards.</li>
                      <li><b>CCPA/CPRA (United States)</b>: Adhering to state-specific privacy regulations.</li>
                      <li><b>LGPD (Brazil)</b>: Respecting user rights and secure data handling.</li>
                      <li><b>PIPEDA (Canada)</b>: Protecting personal information under federal and provincial laws.</li>
                      <li><b>PIPL (China)</b>: Strict consent and data security measures.</li>
                      <li><b>DPDP (India)</b>: Transparency and consent-based processing.</li>
                      <li><b>Privacy Act 1988 (Australia)</b>: Safeguarding data with transparency under APPs.</li>
                      <li><b>POPIA (South Africa)</b>: Respecting data subject rights and privacy.</li>
                    </ul>
                    <p>If you have any questions about your privacy rights, contact us at <a href="mailto:info@dbinsight.ai">info@dbinsight.ai</a></p>
                  </div>

                  {/* <div className="d-flex">
                    <div className="flex-shrink-0 me-3">
                      <FeatherIcon
                        icon="check-circle"
                        className="text-success icon-dual-success icon-xs"
                      />
                    </div>
                    <div className="flex-grow-1">
                      <h5>How we use your information</h5>
                      <p className="text-muted">
                        If you contact us directly, we may receive additional
                        information about you such as your name, email address,
                        phone number, the contents of the message and/or
                        attachments you may send us, and any other information
                        you may choose to provide.
                      </p>
                      <p className="text-muted">
                        Communicate with you, either directly or through one of
                        our partners, including for customer service, to provide
                        you with updates and other information relating to the
                        website, and for marketing and promotional purposes.
                      </p>
                      <p className="text-muted">
                        When you register for an Account, we may ask for your
                        contact information, including items such as name,
                        company name, address, email address, and telephone
                        number.
                      </p>
                      <p className="text-muted">
                        We use the information we collect in various ways,
                        including to:
                      </p>
                      <ul className="text-muted vstack gap-2">
                        <li>Provide, operate, and maintain our website</li>
                        <li>Improve, personalize, and expand our website</li>
                        <li>Understand and analyze how you use our website</li>
                        <li>
                          Develop new products, services, features, and
                          functionality
                        </li>
                        <li>Send you emails</li>
                        <li>Find and prevent fraud</li>
                      </ul>
                      <p className="text-muted">
                        Like any other website, Website Name uses ‘cookies'.
                        These cookies are used to store information including
                        visitors' preferences, and the pages on the website that
                        the visitor accessed or visited. The information is used
                        to optimize the users' experience by customizing our web
                        page content based on visitors' browser type and/or
                        other information.
                      </p>
                    </div>
                  </div> */}

                  
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default PrivacyPolicy;
